module.exports = __webpack_public_path__ + "img/arrow-select.fe400fae.svg";